import { useMutation, useQueryClient } from '@tanstack/react-query';

import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { CreateProcessDTO } from '@app/models/orders';
import Api from '@app/services/api';

export const useCreateProcessQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async (data: CreateProcessDTO) => {
      return await Api.orders.postProcess(data);
    },
    onError: () => {
      message.open({
        type: 'error',
        content: commonT.t('error400'),
      });
    },
    onSuccess: async (data) => {
      await client.invalidateQueries(['getProcesses']);
      message.open({
        type: 'success',
        content: commonT.t('dataAddSuccess'),
      });
      return data;
    },
  });
};
